// Fallback data when Hygraph is unavailable or not configured
import type { Service, Forwho } from "../types/hygraph";

export const fallbackServices: Service[] = [
    {
        id: "fallback-1",
        title: "Sprachliche Unterstützung für Persönliche und Berufliche Angelegenheiten",
        description:
            "Jeglichen anderen persönlichen oder beruflichen Angelegenheiten, die sprachliche Unterstützung erfordern",
    },
    {
        id: "fallback-2",
        title: "Terminvereinbarungen mit Lokalen Behörden und Dienstleistern",
        description:
            "Vereinbarung von Terminen mit lokalen Behörden und Dienstleistern",
    },
    {
        id: "fallback-3",
        title: "Bau- und Renovierungsunternehmen: Suche, Unterstützung und Übersetzung",
        description:
            "Hilfe bei der Suche nach einem Bau- und Renovierungsunternehmen sowie Unterstützung und Übersetzung bei der Festlegung des Renovierungsablaufs.",
    },
    {
        id: "fallback-4",
        title: "Organisation und Kommunikationshilfe für Angelegenheiten in Polen",
        description:
            "Unterstützung bei der Kommunikation und Organisation verschiedener Angelegenheiten in Polen",
    },
    {
        id: "fallback-5",
        title: "Durchdachter Umzug nach Polen",
        description:
            "Ihren Umzug nach Polen reibungslos zu gestalten - von der Suche nach Wohnraum bis zur Integration in das neue Umfeld.",
    },
    {
        id: "fallback-6",
        title: "Effektive Kommunikation mit polnischen Immobilienagenturen",
        description:
            "Die Kommunikation mit Immobilienagenturen in Polen und Ihre Anforderungen klar zu kommunizieren.",
    },
    {
        id: "fallback-7",
        title: "Professionelle Unterstützung bei Dokumenten und Formalitäten in Polen",
        description:
            "Verlassen Sie sich auf unsere Expertise bei der Handhabung von offiziellen Dokumenten und Formalitäten in Polen, damit Sie sich auf Ihr Geschäft konzentrieren können.",
    },
];

export const fallbackForwhos: Forwho[] = [
    {
        id: "fallback-help-1",
        title: "Umziehend nach Polen",
    },
    {
        id: "fallback-help-2",
        title: "Immobilienkäufer",
    },
    {
        id: "fallback-help-3",
        title: "Die Behördenangelegenheiten erledigen",
    },
    {
        id: "fallback-help-4",
        title: "Die einen Dolmetscherin benötigen",
    },
];
